{
  "storefront_widgets_page": {
    "header": {
      "title": "Widgets",
      "description": "To allow B2B customers to place orders, you need to install our B2B storefront widgets onto your website.",
      "footer": "Learn more about storefront widgets",
      "shopify_description": "You can view and manage your theme configuration in your Shopify admin.",
      "shopify_admin": "Open Shopify admin"
    },
    "tabs": {
      "core": "Core Script",
      "pdp": "Product page script",
      "css": "Customise design",
      "tips": "Best-practice tips"
    },
    "copy": "Copy to clipboard",
    "copy_error": "Couldn't copy to the clipboard.",
    "cards": {
      "sparkjs_version": {
        "title": "SparkLayer Core Script",
        "subtitle": "Pin the SparkLayer Core Script to a specific version for this store.",
        "upgrade_required": "Core Script upgrade required",
        "upgrade_note": "To upgrade the SparkLayer Core Script and take advantage of the latest features, there are a few things to be aware of first.",
        "upgrade_guide": "Read the upgrade guide",
        "read_guide": "I have read the guide, let me upgrade",
        "version_label": "SparkLayer Core Script version",
        "save": "Save",
        "save_error": "Couldn't update the Core Script version. Please try again.",
        "help": "Select a different Core Script version for this store.",
        "whats_new": "See what's new"
      }
    },
    "core": {
      "title": "Adding the Core Script",
      "description": "The SparkLayer Core Script renders SparkLayer's storefront interfaces. Within the header of your website, add the following code. You can also update the language or add customisations.",
      "shopify": {
        "title": "Install SparkLayer on your Shopify store",
        "description": "On Shopify, you can install the SparkLayer widgets in three ways:",
        "options": {
          "request": {
            "title": "Request installation",
            "description": "our team can install SparkLayer onto your theme for you"
          },
          "app_block": {
            "title": "App block",
            "description": "install via Shopify's theme editor, no code needed (recommended)"
          },
          "manual": {
            "title": "Manually",
            "description": "paste a snippet into theme.liquid"
          }
        },
        "open_theme_setup": "Open Shopify theme setup",
        "read_guide": "Read installation guide"
      }
    },
    "pdp": {
      "woocommerce_notice_1": "Our plugin offers partial support for some WooCommerce blocks out of the box. If your theme supports block themes, then the SparkLayer widgets should be injected automatically.",
      "woocommerce_notice_2": "If, however, your theme does not support blocks, or uses blocks not supported by SparkLayer, you may include our widgets manually using the instructions below.",
      "example_link": "View interactive example",
      "sections": {
        "pdp": {
          "title": "Product detail page script",
          "description": "To display customer-specific pricing and the ability to add products to an order, you need to update your existing product detail page with the SparkLayer Product Purchasing Interface.",
          "guide": "Read our guide"
        },
        "all_variants": {
          "description": "If your products are available in multiple variant options (e.g. colour and size), it's possible to enable a special \"All Variants\" mode that gives customers an easy way to see all available variants in one go.",
          "guide": "Read our guide"
        },
        "matrix": {
          "description": "If your products come with a lot of variants (e.g. colour and size), you can enable our special \"Matrix View\". This presents all your variants in a matrix table and gives customers a quick way to add items to an order.",
          "guide": "Read our guide"
        },
        "cards": {
          "title": "Collection listing page and product cards",
          "description": "You can display customer-specific pricing and the ability to add products to an order in any location where you show product cards, for example on a collection listing page or on a homepage.",
          "guide": "Read our guide"
        },
        "price": {
          "description": "If you prefer, you can just display a price for a product by using the below code snippet.",
          "guide": "Read our guide"
        },
        "quick_buy": {
          "description": "It's also possible to enable a quick buy mode that displays your products in a special table view. Please note, this does require more advanced coding.",
          "guide": "Read our guide"
        }
      }
    },
    "css": {
      "title": "Customising the design with CSS",
      "description": "You can update the look and feel of the SparkLayer Frontend by using special CSS variables to change styling such as colours, fonts and spacing. We've included a sample below to get you started."
    },
    "tips": {
      "description": "If you're looking to extend the functionality of your B2B store, we've got some handy tips and guides for you!",
      "guide": "See all tips",
      "learn_more": "Learn more",
      "items": {
        "tiered_pricing": {
          "title": "Configure tiered pricing",
          "description": "Tiered pricing lets you set discounts based on the number of units purchased."
        },
        "pack_sizing": {
          "title": "Configure pack sizing rules",
          "description": "Configure your products to sell in minimum quantities and pack sizes."
        },
        "registration_form": {
          "title": "Set up a registration form",
          "description": "Create a registration form that lets wholesale customers apply for access."
        },
        "b2b_only_content": {
          "title": "Show B2B-only content",
          "description": "Adapt your store to hide or show content to B2B customers."
        },
        "hide_show_products": {
          "title": "Hide and show products",
          "description": "Adapt your store to hide or show products to your B2B customers."
        },
        "multi_add": {
          "title": "Add multiple products in one click",
          "description": "Let your customers add multiple products to their order in a single click."
        },
        "pre_order": {
          "title": "Set up pre-order products",
          "description": "Configure specific products in your store to allow pre-ordering."
        },
        "min_quantities": {
          "title": "Configure minimum quantities",
          "description": "Set products to be purchasable in predefined quantities (e.g. 3, 6, 12)."
        },
        "b2b_shipping": {
          "title": "Configure B2B-only shipping",
          "description": "Display different shipping methods for your B2B customers."
        },
        "multi_currency": {
          "title": "Set up multiple currencies",
          "description": "Allow your B2B customers to place orders in different currencies."
        }
      }
    }
  }
}
